import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=cdb79ae2&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=cdb79ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb79ae2",
  null
  
)

export default component.exports